/**
 * Clear leftover platform SW / caches / IndexedDB.
 * PWA is disabled in nuxt.config, but older installs still intercept `/` and
 * `/api/*` (Workbox) and send auth to a stale origin such as :8000.
 *
 * Storefront: wait until idle so IndexedDB work does not inflate TBT.
 * Auth / app: run immediately — a cached SW blocks login.
 */
const WORKBOX_DBS = ['workbox-expiration', 'workbox-background-sync']

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  const route = useRoute()
  const storeHost = useStorefrontHost()
  const isStorefront = route.path.startsWith('/store') || Boolean(storeHost.value.subdomain)

  const run = () => {
    void (async () => {
      try {
        if ('serviceWorker' in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations()
          await Promise.all(regs.map(reg => reg.unregister()))
        }
      }
      catch { /* ignore */ }

      try {
        if (typeof caches !== 'undefined') {
          const keys = await caches.keys()
          await Promise.all(keys.map(key => caches.delete(key)))
        }
      }
      catch { /* ignore */ }

      try {
        for (const name of WORKBOX_DBS) indexedDB.deleteDatabase(name)
      }
      catch { /* ignore */ }
    })()
  }

  if (isStorefront && 'requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 8000 })
    return
  }
  if (isStorefront) {
    window.setTimeout(run, 4000)
    return
  }
  run()
})
